function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.7389 1.88282C62.7569 0.717729 65.2431 0.717728 67.2611 1.88282L116.164 30.1172C118.182 31.2823 119.426 33.4355 119.426 35.7656V92.2344C119.426 94.5645 118.182 96.7177 116.164 97.8828L67.2611 126.117C65.2431 127.282 62.7569 127.282 60.7389 126.117L11.8355 97.8828C9.81752 96.7177 8.57438 94.5645 8.57438 92.2344V35.7656C8.57438 33.4355 9.81752 31.2823 11.8355 30.1172L60.7389 1.88282Z",
  fill: "#002A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0133 74.7231C63.2433 74.0155 64.7568 74.0155 65.9868 74.7231L84.0645 85.1237C86.1949 86.3494 86.1949 89.4233 84.0645 90.6489L65.9868 101.05C64.7568 101.757 63.2433 101.757 62.0133 101.05L43.9356 90.6489C41.8052 89.4233 41.8052 86.3494 43.9356 85.1237L62.0133 74.7231Z",
  fill: "#003FE0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0144 55.1539C63.2437 54.4473 64.7559 54.4473 65.9852 55.1539L90.9888 69.5262C93.1206 70.7515 93.1206 73.8272 90.9888 75.0526L65.9852 89.4248C64.7559 90.1315 63.2437 90.1315 62.0144 89.4248L37.0108 75.0526C34.879 73.8272 34.879 70.7516 37.0108 69.5262L62.0144 55.1539Z",
  fill: "#0070F3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0076 33.7617C63.2404 33.0498 64.7593 33.0498 65.992 33.7617L99.1689 52.9188C101.293 54.1455 101.293 57.2122 99.1689 58.4389L65.992 77.596C64.7593 78.3078 63.2404 78.3078 62.0076 77.596L28.8308 58.4389C26.7062 57.2122 26.7062 54.1455 28.8308 52.9188L62.0076 33.7617Z",
  fill: "#00AAF3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0088 12.3591C63.2411 11.648 64.7591 11.648 65.9914 12.3591L107.522 36.3262C109.648 37.5528 109.648 40.6205 107.522 41.8471L65.9914 65.8142C64.7591 66.5253 63.2411 66.5253 62.0088 65.8142L20.4778 41.8471C18.3523 40.6205 18.3523 37.5528 20.4778 36.3262L62.0088 12.3591Z",
  fill: "white"
});

var SvgSpp = function SvgSpp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SPP.45bf12f8.svg";
export { ForwardRef as ReactComponent };